import React, { type FunctionComponent } from 'react'
import { css } from '@emotion/react'
import { LogOutIcon, TechnicalIcon } from '@instacart/ids-core'
import { FulfillmentTestingCenterIcon, OpenInIcon, UserIcon } from '@instacart/ids-core'
import { spacing, useBooleanState } from '@retailer-platform/shared-components'
import { AccountManagementMyAccountModal } from '@retailer-platform/domain-account-management'
import { NavItem } from '../NavItem'
import { AppDevPortalSectionAccessControl } from '../../../../../sections/dev-portal/DevPortalSection.configuration'
import clientEnv from '../../../../../utils/global/clientEnv'
import useAccessControl from '../../../../../legacy/components/AccessControl/useAccessControl'
import { Permission } from '../../../../../legacy/common/types'
import { AdminControlModal } from '../../../admin-controls-modal/AdminControlsModal'

const iconStyle = css({
  marginRight: spacing.X16,
  marginLeft: 'auto',
  width: '18px',
  height: '18px',
})

export const RetailerNavFooterContent: FunctionComponent = () => {
  const hasAccess = useAccessControl()
  const isInternalAdmin = hasAccess({
    permissions: Permission.AdminPanel,
  })
  const [showMyAccountModal, openMyAccountModal, closeMyAccountModal] = useBooleanState(false)
  const [isAdminControlsOpen, openAdminControls, closeAdminControls] = useBooleanState(false)

  return (
    <>
      <NavItem
        isMainItem
        Icon={UserIcon}
        title="app.admin.nav.links.myAccount"
        onClick={openMyAccountModal}
      />
      <AccountManagementMyAccountModal isOpen={showMyAccountModal} onClose={closeMyAccountModal} />

      {clientEnv.PUBLIC_CLIENT_ENVIRONMENT == 'production' && (
        <NavItem
          isMainItem
          Icon={FulfillmentTestingCenterIcon}
          title="app.devPortal.nav.header"
          accessControl={AppDevPortalSectionAccessControl}
          route="app-dev-portal"
          navBadge={<OpenInIcon css={iconStyle} color="systemGrayscale00" />}
        />
      )}
      {isInternalAdmin && (
        <>
          <NavItem
            isMainItem
            Icon={TechnicalIcon}
            title="app.admin.nav.links.adminControls"
            onClick={openAdminControls}
          />
          <AdminControlModal isOpen={isAdminControlsOpen} onClose={closeAdminControls} />
        </>
      )}
      <NavItem isMainItem Icon={LogOutIcon} route="logout" title="logout" />
    </>
  )
}
